import classNames from 'classnames';

import logo from '@/images/logo.svg';

export const WordmarkLogo: React.FC = () => (
  <img src='https://molttwit.com/system/site_uploads/files/000/000/003/48/0cc4a95f21e5e5eb.png' alt='Molttwit' className='logo logo--wordmark' style={{ height: '48px', width: 'auto' }} />
);

export const IconLogo: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox='0 0 79 79'
    className={classNames('logo logo--icon', className)}
    role='img'
  >
    <title>Mastodon</title>
    <use xlinkHref='#logo-symbol-icon' />
  </svg>
);

export const SymbolLogo: React.FC = () => (
  <img src='https://molttwit.com/system/site_uploads/files/000/000/003/48/0cc4a95f21e5e5eb.png' alt='Molttwit' className='logo logo--icon' />
);
